import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  FORGET_PASSWORD,
  GET_DETAILS_TO_RESET_PASSWORD,
  INIT_URL,
  LOGIN_SUCCESS,
  LOGIN_USER,
  SET_ORG_DATA,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET
} from "../../constants/ActionTypes";

import axios from "util/Api";
import { fetchError, fetchModules, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { history } from "../store/index";
import {
  endSession,
  sessionMode,
  sessionRequestConfig,
  setAccessToken,
  startSession
} from "../../util/session";

export const setInitUrl = url => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const loginUser = ({ username, password }) => {
  return {
    type: LOGIN_USER,
    username,
    password
  };
};

export const loginSuccess = ({ token, user }) => {
  return {
    type: LOGIN_SUCCESS,
    token,
    user
  };
};

export const userSignUp = ({ email, password, name }) => {
  // console.log(email, password);
  return dispatch => {
    dispatch({ type: FETCH_START });
    axios
      .post("auth/register", {
        email: email,
        password: password,
        name: name
      })
      .then(({ data }) => {
        if (data.result) {
          localStorage.setItem(
            "token",
            JSON.stringify(data.token.access_token)
          );
          axios.defaults.headers.common["access-token"] =
            "Bearer " + data.token.access_token;
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: USER_TOKEN_SET, payload: data.token.access_token });
          dispatch({ type: USER_DATA, payload: data.user });
        } else {
          console.log("payload: data.error", data.error);
          dispatch({ type: FETCH_ERROR, payload: "Network Error" });
        }
      })
      .catch(function (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        console.log("Error****:", error.message);
      });
  };
};

export const userSignIn = ({ email, password, organisation }) => {
  return async dispatch => {
    dispatch(fetchStart());
    axios
      .post(
        "auth/login",
        {
          email: email,
          password: password,
          organisation: organisation,
          sessionMode: sessionMode()
        },
        sessionRequestConfig()
      )
      .then(response => {
        startSession(response.data);

        dispatch(fetchSuccess());
        dispatch({ type: USER_TOKEN_SET, payload: response.data.accessToken });
        dispatch(getUser());
        dispatch(fetchModules());
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          dispatch(fetchError(error.response.data.message));
          message.error(error.response.data.message);
          console.log("Error****:", error.response.data.message);
        }
      });
  };
};

export const fetchOrg = slug => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`organisation/slug/${slug}`);
      dispatch(fetchSuccess());
      dispatch({ type: SET_ORG_DATA, payload: response.data });
    } catch (error) {
      dispatch(fetchError(error.response && error.response.data && error.response.data.message || error));
      console.log("Error****:", error);
    }
  };
};

export const getUser = () => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.get("/auth/user");
      // console.log(response)
      localStorage.setItem("user", JSON.stringify(response.data));
      dispatch(fetchSuccess());
      dispatch({ type: USER_DATA, payload: response.data });
    } catch (error) {
      console.log(error);
      if (!error.response) {
        message.error(`Network error, try later!`);
      } else {
        dispatch(fetchError(error.response.data.message));
        console.log("Error****:", error.response.data.message);
      }
    }
  };
};

export const userSignOut = () => {
  return dispatch => {
    dispatch({ type: FETCH_START });
    setTimeout(async () => {
      await endSession();
      localStorage.removeItem("user");
      localStorage.removeItem("last_tag_type");
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SIGNOUT_USER_SUCCESS });
    }, 2000);
  };
};

export const forgotPassword = ({ email, organisation }) => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.post("/auth/forgetPassword", {
        email: email,
        organisation: organisation
      });
      dispatch(fetchSuccess());
      dispatch({ type: FORGET_PASSWORD, payload: response.data });
      message.success("Email to reset password sent!");
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      message.error(error.response.data.message, 7);
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getDetailsToResetPassword = ({ token }) => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/auth/resetPassword?token=${token}`);
      dispatch(fetchSuccess());
      dispatch({ type: GET_DETAILS_TO_RESET_PASSWORD, payload: response.data });
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      message.error(error.response.data.message, 5);
      console.log("Error****:", error.response.data.message);
      history.push("/login");
    }
  };
};

export const resetPassword = ({ token, password }) => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      await axios.post("/auth/resetPassword", {
        token,
        password
      });
      dispatch(fetchSuccess());
      message.success(
        "Password successfully restored, proceed to login with your new password!",
        7
      );
      history.push("/login");
    } catch (error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        "Unable to change password!";
      dispatch(fetchError(errorMessage));
      message.error(errorMessage);
    }
  };
};

export const changePasswordDuringLogin = data => {
  return async dispatch => {
    try {
      const response = await axios.post(`/user/changePassword`, {
        currentPassword: data.currentPassword,
        password: data.password,
        confirmPassword: data.confirmPassword
      });
      //dispatch(fetchSuccess());
      if (response.data === false) {
        message.error("Password not matched", 5);
        history.push("/change-password");
      } else {
        // Changing the password ends all existing sessions; the backend returns a new token for this one
        if (response.data && response.data.accessToken) {
          setAccessToken(response.data.accessToken);
          dispatch({ type: USER_TOKEN_SET, payload: response.data.accessToken });
        }
        message.success("Password successfully changed", 5);
        history.push("/dashboard");
      }
    } catch (error) {
      console.log("Error****:", error);
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
    }
  };
};
